import {InfoPage, RsnButton, RsnDialog, RsnTextButton} from '@raison/ui-kit';
import React from 'react';
import {useSearchModel} from '~/processes/crypto-send-and-receive/lib/useSearchModel';
import {TrTx} from '~/processes/crypto-send-and-receive/model/TrTx';
import {TrtDetailsDialog} from '~/processes/crypto-send-and-receive/ui/SentTrTxDetailsDialog';
import {ParamKey, useGoHome, useGoToSupport} from '../model/SendTxRouting';
import {CalculatedAmounts} from './SendTxIntro';

export function TrTxNotEnoughFundsPage({trt, amounts}: {trt: TrTx; amounts: CalculatedAmounts | null}) {
    const [params, searchCtl] = useSearchModel({
        [ParamKey.dialog]: {details: 'details'},
    });

    const t = {
        Heading: 'Not enough funds',
        Details: (
            <>
                Top up your account or contact us to cancel{' '}
                <span className={'whitespace-nowrap'}>the transaction.</span>
            </>
        ),
        BackToHome: 'Back to home',
        ContactSupport: 'Contact support',
        ViewDetails: 'View operation details',
    };
    return (
        <InfoPage.Layout symbol='attention'>
            {{
                center: (
                    <InfoPage.Center heading={t.Heading} details={t.Details}>
                        <RsnTextButton.Block
                            size={'l'}
                            decoration='arrow-right'
                            onClick={searchCtl.goTo.dialog.details}
                        >
                            {t.ViewDetails}
                        </RsnTextButton.Block>
                    </InfoPage.Center>
                ),
                footer: (
                    <InfoPage.Footer>
                        <RsnTextButton.Block onClick={useGoToSupport()}>{t.ContactSupport}</RsnTextButton.Block>
                        <RsnButton.Primary onClick={useGoHome()}>{t.BackToHome}</RsnButton.Primary>
                        <RsnDialog.Controller onClose={searchCtl.undo.dialog}>
                            {params.dialog === 'details' && <TrtDetailsDialog trt={trt} amounts={amounts} />}
                        </RsnDialog.Controller>
                    </InfoPage.Footer>
                ),
            }}
        </InfoPage.Layout>
    );
}
